import {Map, List} from 'immutable';

import {
  RESOURCE_LIST_REQUEST,
  RESOURCE_LIST_SUCCESS,
  RESOURCE_LIST_FAILURE,
  RESOURCE_READ_REQUEST,
  RESOURCE_READ_SUCCESS,
  RESOURCE_READ_FAILURE,
  RESOURCE_UPDATE_REQUEST,
  RESOURCE_UPDATE_SUCCESS,
  RESOURCE_UPDATE_FAILURE,
  RESOURCE_CREATE_REQUEST,
  RESOURCE_CREATE_SUCCESS,
  RESOURCE_CREATE_FAILURE,
  RESOURCE_DELETE_REQUEST,
  RESOURCE_DELETE_SUCCESS,
  RESOURCE_DELETE_FAILURE,
  RESOURCE_FORM_DESTROY,
  RESOURCE_GEOCODE_REQUEST,
  RESOURCE_GEOCODE_SUCCESS,
  RESOURCE_GEOCODE_FAILURE,
  RESOURCE_CSV_DOWNLOAD_REQUEST,
  RESOURCE_CSV_DOWNLOAD_SUCCESS,
  RESOURCE_CSV_DOWNLOAD_FAILURE
} from './actions'
import Logger from '../../../lib/Logger';

export default function resources(
  state=Map({
    isLoading: false,
    isGeocodeLoading: false,
    isCSVDownloading: false,
    pages: {},
    geocoding: {},
  }),
  action
) {
  Logger.log('debug', `[resources.reducers] resources(%j, %j)`, state, action);

  switch(action.type) {

    case RESOURCE_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true
      });

    case RESOURCE_LIST_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        pages: {
          [action.order]: {
            [action.limit]: {
              [action.page]: null
            }
          }
        },
        total: action.total,
        lastUpdated: action.receivedAt
      }).setIn(['pages', action.order, action.limit, action.page], List(action.result));

    case RESOURCE_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false
      });

    case RESOURCE_READ_REQUEST:
      return state.mergeDeep({
        isLoading: true
      });

    case RESOURCE_READ_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt
      });

    case RESOURCE_READ_FAILURE:
      return state.mergeDeep({
        isLoading: false
      });

    case RESOURCE_UPDATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null
        }
      });

    case RESOURCE_UPDATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          errors: null
        },
        lastUpdated: action.receivedAt
      });

    case RESOURCE_UPDATE_FAILURE:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: false,
          errors: null
        }
      }).setIn(['form', 'errors'], action.error);

    case RESOURCE_CREATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null
        }
      });

    case RESOURCE_CREATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          created_id: action.id,
          errors: null
        },
        lastUpdated: action.receivedAt
      });

    case RESOURCE_CREATE_FAILURE:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: false,
          errors: null
        }
      }).setIn(['form', 'errors'], action.error);

    case RESOURCE_DELETE_REQUEST:
      return state.mergeDeep({
        isLoading: true
      });

    case RESOURCE_DELETE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt
      });

    case RESOURCE_DELETE_FAILURE:
      return state.mergeDeep({
        isLoading: false
      });

    case RESOURCE_FORM_DESTROY:
      return state.mergeDeep({
        form: null
      }).set('form', action.form);

    case RESOURCE_GEOCODE_REQUEST:
      return state.mergeDeep({
        isGeocodeLoading: true
      });

    case RESOURCE_GEOCODE_SUCCESS:
      return state.mergeDeep({
        isGeocodeLoading: false,
        geocoding: {
          [action.location]: null
        },
        lastUpdated: action.receivedAt
      }).setIn(['geocoding', action.location], Map({latitude: action.latitude, longitude: action.longitude}));

    case RESOURCE_GEOCODE_FAILURE:
      return state.mergeDeep({
        isGeocodeLoading: false
      });

    case RESOURCE_CSV_DOWNLOAD_REQUEST:
      return state.mergeDeep({
        isCSVDownloading: true
      });

    case RESOURCE_CSV_DOWNLOAD_SUCCESS:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    case RESOURCE_CSV_DOWNLOAD_FAILURE:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    default:
      return state;
  }
}

Logger.log('silly', `resources.reducers loaded.`);
